import db_lib from 'xAppLib/libs/db_lib';

const _FRDB_LOC = 'site_status';

const _MODEL_NAME = 'site_model';

// ---- --------------------------------------------  --------------------------------------------
// ---- --------------------------------------------  --------------------------------------------

export default class site_model extends db_lib {

	static get FRDB_LOC() { return _FRDB_LOC; }

// ---- --------------------------------------------  --------------------------------------------
// ---- --------------------------------------------  --------------------------------------------

	static watch_average_wait_time(onData) {
		return this.watch_record('wr_stat/prediction/data/average_wait_time', onData);
	}

	static update(data) {
		return this.update_record( '', data, { add_hist: true, add_hist_loc: `${this.FRDB_LOC}_hist` } )
	}

	static set_field(path, data) {
		return this.set_record( path, data, { add_hist: true, add_hist_loc: `${this.FRDB_LOC}_hist`, add_hist_fld: path } )
	}
}

export class pl_site_model extends site_model {
	static get FRDB_LOC() { return 'pl_site_status'; }
}

export class at_site_model extends site_model {
	static get FRDB_LOC() { return 'at_site_status'; }
}